(() => {
  'use strict';
  const REF_PATTERN = /^[A-Za-z0-9]{3,10}$/;
  const TOKEN_PATTERN = /^[A-Za-z0-9._-]{1,100}$/;
  const ATTRIBUTION_KEYS = Object.freeze(['campaign_code','utm_source','utm_medium','utm_campaign','utm_content']);
  const MAX_AGE = 7 * 24 * 60 * 60 * 1000;
  const STORAGE_KEY = 'sasashop_offer_passport_v1';
  const registryNode = document.querySelector('[data-sasa-offer-registry]');
  let registry = {};
  try { registry = JSON.parse(registryNode?.textContent || '{}'); } catch (error) { console.warn('SasaShop offer registry is unavailable.', error); }

  const strictRef = (value) => {
    if (typeof value !== 'string' || value !== value.trim() || !REF_PATTERN.test(value)) return '';
    return value.toUpperCase();
  };
  const strictToken = (value) => typeof value === 'string' && value === value.trim() && TOKEN_PATTERN.test(value) ? value : '';
  const parseSingle = (params, key, parser) => {
    const values = params.getAll(key);
    if (values.length === 0) return Object.freeze({present:false,valid:true,value:''});
    if (values.length !== 1) return Object.freeze({present:true,valid:false,value:''});
    const value = parser(values[0]);
    return Object.freeze({present:true,valid:Boolean(value),value});
  };
  const parseOffer = (params) => parseSingle(params, 'offer', strictRef);
  const parseAttribution = (params) => {
    const parsed = {};
    let present = false;
    for (const key of ATTRIBUTION_KEYS) {
      const result = parseSingle(params, key, strictToken);
      parsed[key] = result;
      present ||= result.present;
      if (!result.valid) return Object.freeze({present:true,valid:false,values:Object.freeze({})});
    }
    const values = Object.fromEntries(ATTRIBUTION_KEYS.map((key) => [key,parsed[key].value]).filter(([,value]) => value));
    return Object.freeze({present,valid:true,values:Object.freeze(values)});
  };
  const findProductForReference = (reference) => Object.entries(registry).find(([,value]) => value.reference === reference)?.[0] || '';
  const clearStored = () => { try { localStorage.removeItem(STORAGE_KEY); } catch (error) { console.warn('SasaShop offer storage could not be cleared.', error); } };
  const readStored = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      const entry = registry[String(value?.productId || '')];
      if (!value || Date.now() >= Number(value.expiresAt || 0) || !entry || entry.reference !== value.reference) { clearStored(); return null; }
      return value;
    } catch (error) { clearStored(); return null; }
  };
  const writeStored = (value) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({...value,expiresAt:Date.now() + MAX_AGE})); }
    catch (error) { console.warn('SasaShop offer storage is unavailable.', error); }
  };

  const query = new URLSearchParams(location.search);
  const parsedOffer = parseOffer(query);
  const parsedAttribution = parseAttribution(query);
  const current = document.querySelector('[data-sasa-offer-passport]');
  const currentProductId = String(current?.dataset.productId || '');
  const currentEntry = registry[currentProductId] || {};
  const expectedReference = strictRef(String(current?.dataset.offerReference || currentEntry.reference || ''));
  const validOfferMatch = Boolean(parsedOffer.present && parsedOffer.valid && expectedReference && parsedOffer.value === expectedReference);
  const explicitInvalidState = (parsedOffer.present && !validOfferMatch) || (parsedAttribution.present && !parsedAttribution.valid);

  if (explicitInvalidState) {
    clearStored();
  } else if (validOfferMatch) {
    const attribution = parsedAttribution.values;
    const campaignCode = attribution.campaign_code || [parsedOffer.value,attribution.utm_source,attribution.utm_content].filter(Boolean).join('-').toUpperCase();
    writeStored({
      productId:currentProductId,
      reference:parsedOffer.value,
      productCode:strictToken(String(current?.dataset.productCode || currentEntry.code || '')),
      campaignCode:strictToken(campaignCode),
      utm:Object.freeze({source:attribution.utm_source || '',medium:attribution.utm_medium || '',campaign:attribution.utm_campaign || '',content:attribution.utm_content || ''})
    });
  } else if (parsedAttribution.present) {
    clearStored();
  }

  const stored = explicitInvalidState ? null : readStored();
  const attributionFor = (productId) => stored && String(stored.productId) === String(productId) ? stored : null;
  const propertiesFor = ({productId,productCode = ''} = {}) => {
    const entry = registry[String(productId)] || {};
    const reference = strictRef(String(entry.reference || ''));
    const code = strictToken(String(productCode || entry.code || ''));
    const properties = {};
    if (reference) properties['Referencia SasaShop'] = reference;
    if (code) properties._sasa_product_code = code;
    const attribution = attributionFor(productId);
    if (!attribution) return properties;
    if (attribution.campaignCode) properties._sasa_campaign_code = attribution.campaignCode;
    for (const key of ['source','medium','campaign','content']) if (attribution.utm?.[key]) properties[`_utm_${key}`] = attribution.utm[key];
    return properties;
  };
  const propertiesForDataset = (element) => propertiesFor({
    productId:element?.dataset?.sasaProductId || element?.dataset?.productId,
    productCode:element?.dataset?.sasaProductCode || element?.dataset?.productCode
  });
  const decorateForm = (form) => {
    const root = form.closest('[data-product-root]');
    const productId = root?.dataset.recentId || currentProductId;
    const properties = propertiesFor({productId,productCode:current?.dataset.productCode});
    const fieldMap = {'reference':'Referencia SasaShop','product-code':'_sasa_product_code','campaign-code':'_sasa_campaign_code','utm-source':'_utm_source','utm-medium':'_utm_medium','utm-campaign':'_utm_campaign','utm-content':'_utm_content'};
    for (const [field,property] of Object.entries(fieldMap)) {
      const input = form.querySelector(`[data-sasa-property="${field}"]`);
      if (!input) continue;
      const value = properties[property] || '';
      input.value = value;
      input.disabled = !value;
    }
  };
  if (current && parsedOffer.present) {
    current.hidden = false;
    const message = current.querySelector('[data-sasa-offer-message]');
    if (validOfferMatch) {
      message.textContent = String(current.dataset.confirmedTemplate || '').replace('__REF__', parsedOffer.value);
    } else {
      current.classList.add('is-invalid');
      current.querySelector('[data-sasa-offer-title]').textContent = '!';
      const belongsElsewhere = parsedOffer.valid && findProductForReference(parsedOffer.value) && findProductForReference(parsedOffer.value) !== currentProductId;
      message.textContent = belongsElsewhere ? current.dataset.mismatchMessage : current.dataset.invalidMessage;
    }
  }
  document.querySelectorAll('[data-product-form]').forEach(decorateForm);
  window.SasaOfferPassport = Object.freeze({strictRef,strictToken,parseOffer,parseAttribution,propertiesFor,propertiesForDataset,registry});
})();
